export default{
  // New Users
  engagement_retention_retention: 'Retention',
  engagement_retention_newusers: 'New Users',
  engagement_retention_activeUsers: 'Active Users',
  engagement_retention_d237RetentionNewUsers: 'D2/3/7 Retention New Users',
  pc_engagement_retention_d237RetentionNewUsers: 'D1/2/3/7 Retention New Users',
  engagement_retention_newUsersRetention: 'New Users Retention',
  engagement_retention_averaged1: 'Average D1',
  pc_engagement_retention_averaged1: 'Average D1',
  pc_engagement_retention_averaged2: 'Average D2',
  engagement_retention_nightingale_averaged2: 'Average D2', // 夜莺的D1是次留，D2是二留
  engagement_retention_averaged2: 'Average D2',
  engagement_retention_averaged3: 'Average D3',
  engagement_retention_averaged7: 'Average D7',
  engagement_retention_retentionNewUsers: 'Retention New Users',
  engagement_retention_date: 'Date',
  engagement_retention_register: 'New',

  engagement_retention_d: 'D{num}',
  engagement_retention_d_new: 'D{num}',
  engagement_retention_d1: 'D1',
  engagement_retention_d2: 'D2',
  pc_engagement_retention_d1: 'D1',
  pc_engagement_retention_d2: 'D2',
  engagement_retention_nightingale_d2: 'D2',// 夜莺的D1是次留，D2是2留
  engagement_retention_d3: 'D3',
  engagement_retention_d4: 'D4',
  engagement_retention_d5: 'D5',
  engagement_retention_d6: 'D6',
  engagement_retention_d7: 'D7',
  engagement_retention_d14: 'D14',
  engagement_retention_d30: 'D30',
  engagement_retention_d60: 'D60',

  engagement_retention_w: 'W{num}',
  engagement_retention_w_new: 'W{num}',
  engagement_retention_w2: 'W2',
  engagement_retention_w3: 'W3',
  engagement_retention_w4: 'W4',
  engagement_retention_w5: 'W5',
  engagement_retention_w6: 'W6',
  engagement_retention_w7: 'W7',
  engagement_retention_w14: 'W14',
  engagement_retention_w30: 'W30',
  engagement_retention_w60: 'W60',

  engagement_retention_m: 'M{num}',
  engagement_retention_m_new: 'M{num}',
  engagement_retention_m2: 'M2',
  engagement_retention_m3: 'M3',
  engagement_retention_m4: 'M4',
  engagement_retention_m5: 'M5',
  engagement_retention_m6: 'M6',
  engagement_retention_m7: 'M7',
  engagement_retention_m14: 'M14',
  engagement_retention_m30: 'M30',
  engagement_retention_m60: 'M60',

  engagement_retention_percentage: 'Percentage',
  engagement_retention_keydays: 'Key Days',
  engagement_retention_230days: '1 ~ 30 Days',
  engagement_retention_260days: '1 ~ 60 Days',
  engagement_retention_290days: '1 ~ 90 Days',
  engagement_retention_2180days: '1 ~ 180 Days',
  engagement_retention_2360days: '1 ~ 360 Days',
  // Active Users
  engagement_retention_d237retentionactiveusers: 'D2/3/7 Retention Active Users',
  pc_engagement_retention_d237retentionactiveusers: 'D1/2/3/7 Retention Active Users',
  engagement_retention_activeusersretention: 'Active Users Retention',
  engagement_retention_retentionActiveUsers: 'Retention Active Users',
  engagement_retentionactiveUsers: 'Active Users',

  engagement_retention_user: 'Retention User',
  engagement_retention_rate: 'Retention Rate',
  engagement_retention_average: 'Average',

  engagement_retention_d1d237_retention_new_users: 'D1/2/3/7 Return Rate -New Users',
  engagement_retention_d1d237_return_retention_actve_users: 'D1/2/3/7 Return Rate -Active Users',
  engagement_retention_d1d237_roll_retention_new_users: 'D1/2/3/7 Rolling Retention -New Users',
  engagement_retention_d1d237_roll_retention_active_users: 'D1/2/3/7 Rolling Retention -Active Users',
  engagement_retention_return_rate_new_users: 'Return Rate -New Users',
  engagement_retention_return_rate_active_users: 'Return Rate -Active Users',
  engagement_retention_roll_rate_new_users: 'Rolling Retention -New Users',
  engagement_retention_roll_rate_active_users: 'Rolling Retention -Active Users',
  
};